export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-charcoal-900 pt-20 pb-10">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 mb-16">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-6">
            <img
              src="/images/udesign-mark-112.webp"
              alt="U Design Studio"
              width="112"
              height="112"
              loading="lazy"
              className="w-9 h-9 object-contain"
            />
              <span className="font-sans text-xs text-stone-400 tracking-[0.25em] uppercase whitespace-nowrap">
                U Design Studio
              </span>
            </div>
            <p className="text-stone-400 text-sm leading-relaxed max-w-xs">
              Melbourne building design, interiors and project coordination — connected from first idea to delivery.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-sans text-xs text-stone-400 tracking-[0.2em] uppercase mb-5 whitespace-nowrap">Navigate</h4>
            <div className="flex flex-col gap-3">
              <a href="/" className="text-stone-300 text-sm hover:text-cream-50 transition-colors duration-300 whitespace-nowrap">Home</a>
              <a href="/services" className="text-stone-300 text-sm hover:text-cream-50 transition-colors duration-300 whitespace-nowrap">Services</a>
              <a href="/residential-development-design-melbourne" className="text-stone-300 text-sm hover:text-cream-50 transition-colors duration-300">Townhouse Design</a>
              <a href="/custom-home-design-melbourne" className="text-stone-300 text-sm hover:text-cream-50 transition-colors duration-300">Custom Homes</a>
              <a href="/portfolio" className="text-stone-300 text-sm hover:text-cream-50 transition-colors duration-300 whitespace-nowrap">Portfolio</a>
              <a href="/contact" className="text-stone-300 text-sm hover:text-cream-50 transition-colors duration-300 whitespace-nowrap">Contact</a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-sans text-xs text-stone-400 tracking-[0.2em] uppercase mb-5 whitespace-nowrap">Contact</h4>
            <div className="flex flex-col gap-3">
              <a href="mailto:admin@udesignstudio.com.au" className="text-stone-300 text-sm hover:text-terracotta-400 transition-colors duration-300 whitespace-nowrap">
                admin@udesignstudio.com.au
              </a>
              <a href="tel:+61390086321" className="text-stone-300 text-sm hover:text-terracotta-400 transition-colors duration-300 whitespace-nowrap">
                (03) 9008 6321
              </a>
              <p className="text-stone-400 text-sm leading-relaxed">
                Suite 218/89 High St<br />
                Kew VIC 3101
              </p>
            </div>
          </div>

          {/*
            Social profiles are not published yet. When the real Instagram /
            LinkedIn pages exist, un-comment this block and drop the URLs in.

          <div className="md:col-span-2">
            <h4 className="font-sans text-xs text-stone-400 tracking-[0.2em] uppercase mb-5 whitespace-nowrap">Follow</h4>
            <div className="flex items-center gap-4">
              <a
                href="REPLACE_WITH_INSTAGRAM_URL"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-stone-600 text-stone-400 hover:text-cream-50 hover:border-cream-50 transition-all duration-300 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line"></i>
              </a>
              <a
                href="REPLACE_WITH_LINKEDIN_URL"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-stone-600 text-stone-400 hover:text-cream-50 hover:border-cream-50 transition-all duration-300 cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill"></i>
              </a>
            </div>
          </div>
          */}
        </div>

        <div className="border-t border-stone-700 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-stone-500 text-xs">
            &copy; {new Date().getFullYear()} U Design Studio. All rights reserved.
          </p>
          <button
            onClick={scrollToTop}
            className="text-stone-400 text-xs hover:text-terracotta-400 transition-colors duration-300 cursor-pointer flex items-center gap-1 whitespace-nowrap"
          >
            Back to top
            <i className="ri-arrow-up-line text-sm"></i>
          </button>
        </div>
      </div>
    </footer>
  );
}
